/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFinancementClasseGridDto } from './FcbFinancementClasseGridDto';
import {
    FcbFinancementClasseGridDtoFromJSON,
    FcbFinancementClasseGridDtoFromJSONTyped,
    FcbFinancementClasseGridDtoToJSON,
} from './FcbFinancementClasseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFinancementClasseGridDtoPaginatedResults
 */
export interface FcbFinancementClasseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFinancementClasseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFinancementClasseGridDto>}
     * @memberof FcbFinancementClasseGridDtoPaginatedResults
     */
    results?: Array<FcbFinancementClasseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFinancementClasseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFinancementClasseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFinancementClasseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFinancementClasseGridDtoPaginatedResultsFromJSON(json: any): FcbFinancementClasseGridDtoPaginatedResults {
    return FcbFinancementClasseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFinancementClasseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFinancementClasseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFinancementClasseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFinancementClasseGridDtoPaginatedResultsToJSON(value?: FcbFinancementClasseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFinancementClasseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

